import React from 'react'
import {ParagraphText} from '@thryvlabs/maverick'

const FutureInvoicesNotice = ({style = {}}) => {
  const baseStyle = {
    fontSize: '14px',
    fontFamily:
      'Open Sans, Helvetica Neue, Helvetica, Helvetica, Arial, sans-serif',
    color: '#4D4D4D',
    marginTop: '16px',
    marginBottom: '0px',
  }

  return (
    <ParagraphText variant="sm" style={{...baseStyle, ...style}}>
      Future invoices will include any eligible discount for as long as your
      account qualifies.
    </ParagraphText>
  )
}

export {FutureInvoicesNotice}
